import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MoonIcon, SunIcon, HeartIcon, HomeIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
const pillars = [{
  icon: MoonIcon,
  title: 'Rutinas nocturnas',
  description: 'Pasos claros para preparar la noche con calma y estructura.'
}, {
  icon: SunIcon,
  title: 'Entrenamiento diurno',
  description: 'Ejercicios y hábitos que refuerzan el control durante el día.'
}, {
  icon: HeartIcon,
  title: 'Gestión emocional',
  description: 'Herramientas para manejar frustraciones sin culpa ni presión.'
}, {
  icon: HomeIcon,
  title: 'Organización del entorno',
  description: 'Cómo preparar el espacio para facilitar el proceso.'
}];
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <SectionWrapper background="light-blue" data-id="element-171">
      <div ref={ref} data-id="element-172">
        <div className="text-center mb-12" data-id="element-173">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-4" data-id="element-174">
            Un método claro, ordenado y respetuoso
          </h2>
          <p className="text-navy/70 text-lg max-w-2xl mx-auto" data-id="element-175">
            Noches Secas trabaja cuatro áreas fundamentales para acompañar a tu
            hijo en este proceso.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-176">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.1 + index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-177">
              <div className="w-12 h-12 rounded-full bg-soft-blue/10 flex items-center justify-center mb-4" data-id="element-178">
                <pillar.icon className="w-6 h-6 text-soft-blue" data-id="element-179" />
              </div>
              <h3 className="font-serif text-xl text-navy mb-2" data-id="element-180">
                {pillar.title}
              </h3>
              <p className="text-navy/60" data-id="element-181">{pillar.description}</p>
            </motion.div>)}
        </div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.5
      }} className="max-w-3xl mx-auto" data-id="element-182">
          <img src="https://cdn.magicpatterns.com/uploads/84D6ommtMxhNQTxGiY3e6q/4._.png" alt="Niño durmiendo tranquilamente mientras su madre lo observa con calma" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-183" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.6
      }} className="text-center text-navy font-medium text-lg mt-8" data-id="element-184">
          Todo desde el acompañamiento, no desde la presión.
        </motion.p>
      </div>
    </SectionWrapper>;
}